var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveSquatting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 148,
    viewBox: "0 0 279 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 134.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 84.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.5,
    cy: 36.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 16.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.5,
    cy: 103.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.5,
    cy: 125.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 31 148)",
    fill: "#24284E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.5 68.5L273.5 70.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.5 19L250.5 15.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.5L45.5 15.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 57L26 54.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10819_8334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.488 121.914C179.322 123.301 196.525 108.347 197.912 88.5129C199.299 68.6791 184.345 51.4763 164.511 50.0894C144.677 48.7024 127.474 63.6566 126.087 83.4904C124.7 103.324 139.655 120.527 159.488 121.914Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.468,
    cy: 69.3788,
    r: 4.15385,
    transform: "rotate(4 162.468 69.3788)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32 78.5346L158.436 77.4238",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.435 77.4235L151.993 90.1589",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.198 77.6168L154.755 90.3523",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.993 90.1602L164.77 91.0536L158.03 103.074L163.21 103.436",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10819_8334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.953 102.932C119.38 101.853 131.011 88.4732 129.932 73.0469C128.853 57.6206 115.473 45.9896 100.047 47.0683C84.6207 48.147 72.9897 61.527 74.0684 76.9533C75.1471 92.3796 88.5271 104.011 103.953 102.932Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.562,
    cy: 62.146,
    r: 3.23077,
    transform: "rotate(-4 100.562 62.146)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.681 67.9154L98.3262 68.7793",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3265 68.7796L94.743 79.2859",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.475 68.6292L96.8914 79.1355",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7432 79.2852L104.681 78.5903L100.791 88.5782L104.819 88.2965",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10819_8334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.491 50.8668C192.673 52.2523 204.483 42.6892 205.868 29.507C207.254 16.3248 197.69 4.51528 184.508 3.12978C171.326 1.74427 159.516 11.3074 158.131 24.4896C156.745 37.6718 166.309 49.4813 179.491 50.8668Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.698,
    cy: 15.9341,
    r: 2.76923,
    transform: "rotate(6 182.698 15.9341)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.381 22.3108L179.824 21.2012",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.824 21.2004L175.236 29.5356",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66 21.3938L177.072 29.729",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.235 29.5352L183.727 30.4277L178.957 38.2798L182.4 38.6416",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10819_8334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0901 49.8876C102.075 48.733 110.045 38.8918 108.89 27.9066C107.735 16.9214 97.8942 8.95211 86.909 10.1067C75.9238 11.2613 67.9545 21.1025 69.1091 32.0877C70.2637 43.0729 80.1049 51.0422 91.0901 49.8876Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.6525,
    cy: 20.8566,
    r: 2.30769,
    transform: "rotate(-6 87.6525 20.8566)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0194 24.7238L86.2217 25.6484",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2222 25.6491L83.926 33.2384",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7525 25.487L85.4562 33.0763",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9258 33.2383L91.0023 32.4945L88.4746 39.7214L91.3433 39.4199",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_10819_8334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.258 80.9249C216.262 81.8876 225.962 73.7478 226.925 62.7441C227.888 51.7404 219.748 42.0398 208.744 41.0771C197.741 40.1144 188.04 48.2542 187.077 59.2579C186.115 70.2615 194.254 79.9622 205.258 80.9249Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.422,
    cy: 51.7715,
    r: 2.30769,
    transform: "rotate(5 207.422 51.7715)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.917 56.9741L205.104 56.2031",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.104 56.2018L201.402 63.2135",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.637 56.3365L202.934 63.3482",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.402 63.2148L208.491 63.835L204.631 70.4468L207.504 70.6982",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_10819_8334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2275 71.8427C76.9781 70.6129 83.0748 62.5222 81.845 53.7716C80.6152 45.0211 72.5245 38.9243 63.774 40.1541C55.0234 41.3839 48.9266 49.4746 50.1565 58.2251C51.3863 66.9757 59.477 73.0725 68.2275 71.8427Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.6681,
    cy: 48.7295,
    r: 1.84615,
    transform: "rotate(-8 64.6681 48.7295)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6663 51.6147L63.6582 52.5996",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6583 52.5988L62.0343 58.7307",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.877 52.427L63.2531 58.5588",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0352 58.7305L67.6721 57.9382L65.853 63.7868L68.1382 63.4656",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_10819_8334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.44 58.8934C150.845 57.5456 162.241 43.9647 160.893 28.5596C159.546 13.1545 145.965 1.75874 130.559 3.10651C115.154 4.45429 103.759 18.0352 105.106 33.4403C106.454 48.8455 120.035 60.2412 135.44 58.8934Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.337,
    cy: 18.1732,
    r: 3.23077,
    transform: "rotate(-5 131.337 18.1732)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.556 23.7644L129.219 24.8438",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.218 24.8433L125.818 35.4106",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.364 24.6578L127.964 35.225",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.818 35.4121L135.742 34.5439L132.027 44.5982L136.05 44.2463",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 90C59 88.8954 59.8954 88 61 88H81.2654C82.2607 88 83.1046 88.7319 83.2453 89.7172L86.7547 114.283C86.8954 115.268 87.7393 116 88.7346 116H189.265C190.261 116 191.105 115.268 191.245 114.283L194.755 89.7172C194.895 88.7319 195.739 88 196.735 88H217C218.105 88 219 88.8954 219 90V116V142C219 143.105 218.105 144 217 144H187H91H61C59.8954 144 59 143.105 59 142V116V90Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10819_8334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(128.599 47.5781) rotate(4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10819_8334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(72.1152 49.0215) rotate(-4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10819_8334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(160.64 0.621094) rotate(6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10819_8334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(67.0186 12.1973) rotate(-6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_10819_8334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(188.82 39.334) rotate(5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_10819_8334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(47.9297 42.3809) rotate(-8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_10819_8334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(102.666 5.54688) rotate(-5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveSquatting);
export default __webpack_public_path__ + "static/media/collective-squatting.4c34efcfbfbd6fea1c54ae67d9f3b2bd.svg";
export { ForwardRef as ReactComponent };